import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { useNkStyles } from '../../infrastructure/theme';

type NkSwitchProps = {
  name?: string;
  color?: 'default' | 'primary' | 'secondary';
  label?: string;
  size?: 'medium' | 'small';
  value?: boolean;
  onChange: (propName?: string) => () => void;
  propName: string;
};

const NkSwitch = (props: NkSwitchProps) => {
  const classes = useNkStyles();

  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <Switch
            name={props.name}
            checked={props.value}
            onChange={props.onChange(props.propName)}
            value={props.propName}
            color={props.color}
          />
        }
        label={props.label}
      />
    </FormGroup>
  );
};

NkSwitch.propTypes = {
  label: PropTypes.string,
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  name: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'small']),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  propName: PropTypes.string.isRequired,
};

export default NkSwitch;
